module.exports = __webpack_public_path__ + "img/PETN-Decomposition-Onset-Temperatures-min.444adb03.png";